import { SVGProps } from '../types';

const BitcoinIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M22.5801 5.33337C28.4232 5.33342 33.1602 10.0703 33.1602 15.9135C33.1601 21.7566 28.4232 26.4935 22.5801 26.4935C16.7369 26.4935 12 21.7566 12 15.9135C12 10.0703 16.7369 5.33337 22.5801 5.33337ZM21.8604 11.1722L19.5088 10.5912L19.1992 11.8324C19.2303 11.8395 20.0509 12.0265 20.0459 12.0414C20.5175 12.1593 20.6035 12.4705 20.5889 12.7172L19.2803 17.9437C19.2224 18.0858 19.0754 18.2999 18.7461 18.2191C18.7408 18.2305 17.9203 18.014 17.8984 18.0082L17.3193 19.3383L19.667 19.9281L19.1846 21.8578L20.3486 22.1478L20.8271 20.2386C21.1451 20.3239 21.4548 20.4042 21.7568 20.4789L21.2803 22.3783L22.4453 22.6683L22.9287 20.7426C24.9168 21.1168 26.4121 20.9653 27.041 19.1742C27.372 17.9298 27.0153 16.9002 25.9697 16.3578C26.7318 16.1831 27.3055 15.6843 27.459 14.6537C27.6702 13.2455 26.5936 12.4882 25.1221 11.9828L25.5996 10.0746L24.4346 9.78455L23.9697 11.6429C23.6638 11.5669 23.3484 11.4949 23.0352 11.4242L23.5029 9.55408L22.3379 9.26404L21.8604 11.1722ZM21.8477 16.2845C22.6388 16.4811 25.1711 16.8708 24.7949 18.3744C24.4338 19.8153 21.9978 19.0372 21.207 18.8412L21.8477 16.2845ZM22.7197 12.7963C23.3784 12.9603 25.4972 13.2655 25.1553 14.6332C24.826 15.9429 22.7982 15.2785 22.1396 15.1156L22.7197 12.7963Z"
      fill="#F7931A"
    />
  </svg>
);

export { BitcoinIcon };
